import React from 'react';
import moment from 'moment';
import Date from './Date';
import Location from './Location';
import RegistrationCap from './RegistrationCap';
import TimeRange from './TimeRange';
import TimeZone from './TimeZone';
import Trainer from './Trainer';
import VideoConference from './VideoConference';
import SessionName from './SessionName';
import DeleteSession from './DeleteSession';

const SessionForm = ({
  session,
  sessions,
  id,
  users,
  currentUser,
  currentCompany,
  timeZones,
  canEditTime,
  isVideoMeetingHost = true,
  isMultiSession,
  handleStartTimeChange,
  handleEndTimeChange,
  handleTimeZoneChange,
  handleTrainerChange,
  handleCapOptionsChange,
  handleSessionInputChange,
  handleVideoConferenceChange,
  handleSessionNameChange,
  handleDeleteSession,
  viaAddSessionModal,
  isEditingSession,
}) => {
  return (
    <div className="EventSessionForm">
      {isMultiSession && (
        <SessionName
          className="mb-16"
          value={session?.name}
          onChange={handleSessionNameChange}
          id={id}
          startTime={session?.startTime}
          endTime={session?.endTime}
          timeZone={session?.timeZone}
        />
      )}
      <Date
        viaAddSessionModal={viaAddSessionModal}
        value={moment(session?.startTime)}
        onChange={handleStartTimeChange}
        disabled={!canEditTime || !isVideoMeetingHost}
        id={id}
      />
      <div className="EventSessionForm-field d-f ai-fe">
        <TimeRange
          viaAddSessionModal={viaAddSessionModal}
          className="f-sh-0"
          ariaRequired="true"
          startTime={session?.startTime}
          endTime={session?.endTime}
          onStartTimeChange={handleStartTimeChange}
          onEndTimeChange={handleEndTimeChange}
          disabled={!canEditTime || !isVideoMeetingHost}
          id={id}
        />
        <TimeZone
          className="ml-24 fg-1"
          value={session?.timeZone}
          onChange={handleTimeZoneChange}
          timeZones={timeZones}
          disabled={!canEditTime || !isVideoMeetingHost}
          id={id}
        />
      </div>
      <Trainer
        users={users}
        onChange={handleTrainerChange}
        value={session?.trainerId}
        id={id}
      />
      <RegistrationCap
        disabled={!canEditTime}
        capOption={session?.capOption}
        maxAttendees={session?.maxAttendees}
        onCapOptionsChange={handleCapOptionsChange}
        onMaxAttendeesChange={handleSessionInputChange}
        id={id}
      />
      <VideoConference
        videoMeeting={session?.videoMeeting}
        onChange={handleVideoConferenceChange}
        currentUser={currentUser}
        currentCompany={currentCompany}
        disabled={!canEditTime || !isVideoMeetingHost}
        timeZones={timeZones}
        startTime={session?.startTime}
        timeZone={session?.timeZone}
        offSet={session?.offSet}
        sessionId={id}
      />
      <Location
        value={session?.location}
        onChange={handleSessionInputChange}
        label={t('in_person_training.new_event.location')}
        id={id}
      />
      {isMultiSession && !isEditingSession && (
        <DeleteSession
          id={id}
          sessions={sessions}
          onChange={handleDeleteSession}
        />
      )}
    </div>
  );
};

export default SessionForm;
